/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import type { ColumnType } from 'antd/es/table';

import { UserSubtenant } from '@/client';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Link } from '@/primitives/Link';
import { Text } from '@/primitives/Text';

export function useUserDetailsSubtenantListColumns(tenantID: string): ColumnType<UserSubtenant>[] {
  const { t } = useMimicTranslation('users');
  const { t: s } = useMimicTranslation('subtenants');
  const columns: ColumnType<UserSubtenant>[] = [
    {
      title: <span data-testid="subtenant-name">{t('name')}</span>,
      dataIndex: 'subtenant',
      render: (_, subtenant) => {
        return (
          <Link
            to={`/tenants/${tenantID}/subtenants/${subtenant.subtenant.id}`}
            style={{ fontSize: 'inherit', fontFamily: 'DM Mono' }}
            dataTestId="subtenant-link"
          >
            <Text type="link" size="md">
              {subtenant.subtenant.name}
            </Text>
          </Link>
        );
      },
    },
    {
      title: <span data-testid="subtenant-role">{t('role')}</span>,
      dataIndex: 'subtenant',
      width: '50%',
      render: (_, subtenant) => {
        return (
          <Text type="default" size="md">
            {subtenant.role === 'none'
              ? s('roles.noAccess')
              : subtenant.role[0].toUpperCase() + subtenant.role.slice(1)}
          </Text>
        );
      },
    },
  ];

  return columns;
}
